module.exports = __webpack_public_path__ + "img/mappin2.e587aba4.png";